import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "unmatched-emails",
      path: "unmatched-emails",
      meta: {
        auth: () => store.getters.isAdmin(),
        icon: "email_fail",
        title: i18n.global.t("Unmatched Emails"),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/UnmatchedEmails"),
    },
  ],

  dialogs: [],
};
